import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";

class ApaMetadataTask extends AbstractRequestTask {
  constructor(region = "", appKey = '') {
    super();

    this.region = region;
    this.appKey = appKey;
  }

  isValid (data){
    return (typeof data == 'object')

  }

  getUrl() {
    return `${Device.getDevice().getConfig().akamai_mfwk}/services/apa/metadata`;
  }

  getParams() {
    const params = super.getParams();

    const appKey = this.appKey ? this.appKey : Device.getDevice().getConfig().appKey;
    const region = this.region || params.region;
    const sessionKey = `${appKey}-${region}`;

    const newParams = {
      sessionKey,
      region
    };

    return Object.assign({}, params, newParams);
  }

  success(data, b) {
    this.resolve(data);
  }

  getRetriesNumber() {
    if (this.appKey) {
      return 0;
    }
  }
}

export default ApaMetadataTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/ApaMetadataTask.js